import { useState, useEffect, useCallback, memo } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import Form from "react-bootstrap/Form";
import SearchModal from "./SearchModal";
import { usePlatform } from "../../hooks/usePlatform";

export const SearchBox = memo(() => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { isMacOS } = usePlatform();
  const initialQ = searchParams.get("q") ?? "";

  const [showModal, setShowModal] = useState(false);
  const [query, setQuery] = useState(initialQ);

  useEffect(() => {
    setQuery(initialQ);
  }, [initialQ]);

  const handleInputClick = useCallback((e) => {
    e.preventDefault();
    setShowModal(true);
  }, []);

  const handleKeyDown = useCallback((e) => {
    if ((e.metaKey || e.ctrlKey) && e.key === "k") {
      e.preventDefault();
      setShowModal(true);
    }
    // Close modal on Escape key
    if (e.key === "Escape" && showModal) {
      setShowModal(false);
    }
  }, [showModal]);

  const handleOnModalClose = useCallback(() => {
    setShowModal(false);
    setQuery("");
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal]);

  const handleModalQueryChange = useCallback((newQuery) => {
    setQuery(newQuery);
  }, []);

  return (
    <>
      <div
        onClick={handleInputClick}
        className={`search-box position-relative flex-grow-1 ${
          query ? "on-focus" : "kbd-ready"
        }`}
      >
        <div className="search-box__icon position-absolute start-0">
          <i className="bi bi-search" aria-hidden="true"></i>
        </div>
        <Form.Control
          type="text"
          id="search-start"
          value={query}
          autoComplete="off"
          readOnly
          placeholder={t("search.placeholder")}
        />
        <div className="search-box__shortcut position-absolute end-0 d-none d-lg-block">
          {isMacOS ? (
            <kbd className="text-secondary">⌘</kbd>
          ) : (
            <kbd className="text-secondary small">Ctrl</kbd>
          )}
          <span className="text-secondary small">+</span>
          <kbd className="text-secondary small">k</kbd>
        </div>
      </div>

      <SearchModal
        show={showModal}
        onHide={handleOnModalClose}
        query={query}
        onQueryChange={handleModalQueryChange}
      />
    </>
  );
});
